module.exports = new __parcel__URL__("AudioBriefingChangeboardingIllustrationDark.b0a7cb34.svg").toString();